// import CarAdd from "pages/cars/CarAdd";
import InDevelop from "components/InDevelop";
import { NotFoundBlock } from "components/NotFoundBlock";
import { SSO } from "components/SSO";
import Home from "pages/Home";
import SignIn from "pages/auth/SignIn";
import { Main as CodePage } from "pages/code/Main";
import ErrorPage from "pages/error-page";
import MainPage from "pages/main/MainPage";
import { OrdersList } from "pages/orders/List";
import { OrdersPage } from "pages/orders/Main";
import { OrdersSearch } from "pages/orders/Search";
import OrderProfile from "pages/orders/info/Main";
import { SettingsBody } from "pages/settings/SettingsBody";

import { createBrowserRouter } from "react-router-dom";
export const router = createBrowserRouter([
  {
    children: [
      {
        element: <MainPage />,
        path: "/",
      },

      {
        element: <SettingsBody />,
        path: "settings",
      },
      {
        element: <CodePage />,
        path: "code",
      },
      {
        children: [
          {
            element: <OrdersSearch />,
            path: "",
          },
          {
            element: <OrderProfile />,
            path: ":id",
          },

          {
            element: <OrdersList />,
            path: "list",
          },
        ],
        element: <OrdersPage />,
        path: "orders",
      },
      {
        element: <ErrorPage />,
        path: "404",
      },
      {
        element: <SSO />,
        path: "silent-check-sso",
      },
    ],
    element: <Home />,
    errorElement: <ErrorPage />,
    path: "",
  },
]);
